// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2GqOw","total":"Cart_total__14y4D","actions":"Cart_actions__1dLnc","button--alt":"Cart_button--alt__32qso","button":"Cart_button__2_MOs"};